import globalScope from 'core/globalScope';

const window = globalScope.window;

let event;
if (window.tc_events_1) {
  event = window.tc_events_1;
} else {
  console.warn('fonction tc_events_1 non pr\u00E9sente sur la page');
  event = function() {};
}

export default {
  tc_events_1: event
};
